export type Make = 'MONO' | 'MASTER' | 'KRAFT_PRINT' | 'BUFFER';

export interface BoxType {
  key: string;
  make: Make | null;
  label: string;
  short: string;
  tick: string[];
  note: string;
}

export const BOX_TYPES: BoxType[] = [
  {
    key: 'printed', make: null, label: 'Printed Carton Box', short: 'Printed',
    tick: ['Printing', 'Corrugation', 'Die Cutting', 'Folder Gluer'],
    note: '',
  },
  {
    key: 'mono', make: 'MONO', label: 'Mono carton', short: 'Mono',
    tick: ['Printing', 'Die Cutting', 'Folder Gluer'],
    note: 'No corrugation',
  },
  {
    key: 'master', make: 'MASTER', label: 'Master box', short: 'Master',
    tick: ['Corrugation', 'Die Cutting', 'Folder Gluer'],
    note: 'No printing',
  },
  {
    key: 'kraft', make: 'KRAFT_PRINT', label: 'Kraft printing', short: 'Kraft print',
    tick: ['Printing', 'Corrugation', 'Die Cutting', 'Folder Gluer'],
    note: 'Layer 1 is printed kraft',
  },
  {
    key: 'buffer', make: 'BUFFER', label: 'Buffer', short: 'Buffer',
    tick: ['Corrugation', 'Die Cutting', 'Folder Gluer'],
    note: 'No printing',
  },
];

/**
 * Job work given to us is not a box we make, so none of the five types above
 * applies -- it differs order to order, so there is no preset: just tick
 * whatever stages this one needs below.
 */
export const JOB_WORK_LABEL = 'Other jobs';

export const faceChoosable = (make: string | null | undefined) => make === 'MASTER' || make === 'BUFFER';

export const boxType = (key: string | null) => BOX_TYPES.find((t) => t.key === key) ?? null;

export const typeOfMake = (make: string | null | undefined) =>
  BOX_TYPES.find((t) => t.make === (make ?? null)) ?? BOX_TYPES[0]!;

export const makeLabel = (make: string | null | undefined) => (make ? typeOfMake(make).label : '');
